import { Controller } from 'stimulus'
import Dropkick from 'dropkickjs'

export default class extends Controller {
  static targets = ['select']

  connect() {
    new Dropkick(this.selectTarget, {
      mobile: true,
      initialize() {
        document.querySelectorAll('.event-hero__time').forEach(el => {
          el.style.display = 'none'
        })
        document.querySelector(`[data-date*='${this.value}']`).style.display = 'block'
      },
      change() {
        document.querySelectorAll('.event-hero__time').forEach(el => {
          el.style.display = 'none'
        })
        document.querySelector(`[data-date*='${this.value}']`).style.display = 'block'
      }
    })
  }

}
